import { useState, useEffect } from "react";
import { Button } from "@/components/ui/button";
import { Shield } from "lucide-react";

export default function CookieConsent() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem("berkshire_cookie_consent");
    if (!consent) {
      const timer = setTimeout(() => setVisible(true), 1500);
      return () => clearTimeout(timer);
    }
  }, []);

  const accept = () => {
    localStorage.setItem("berkshire_cookie_consent", "accepted");
    setVisible(false);
  };

  const decline = () => {
    localStorage.setItem("berkshire_cookie_consent", "declined");
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      data-testid="cookie-consent-banner"
      className="fixed bottom-0 left-0 right-0 z-50 animate-fade-in-up"
      style={{ animationDuration: "0.4s" }}
    >
      <div className="bg-[#0f172a] border-t border-slate-700 px-6 py-4 md:px-12">
        <div className="max-w-7xl mx-auto flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
          <div className="flex items-start gap-3">
            <Shield className="w-5 h-5 text-blue-400 mt-0.5 shrink-0" />
            <p className="text-slate-300 text-sm font-manrope leading-relaxed">
              We use cookies to enhance your experience, analyze site traffic, and personalize content.
              By continuing to use this site, you consent to our use of cookies in accordance with our privacy policy.
            </p>
          </div>
          <div className="flex items-center gap-3 shrink-0">
            <Button
              data-testid="cookie-decline-button"
              variant="ghost"
              onClick={decline}
              className="text-slate-400 hover:text-white hover:bg-slate-800 text-sm px-4 h-9"
            >
              Decline
            </Button>
            <Button
              data-testid="cookie-accept-button"
              onClick={accept}
              className="bg-blue-600 hover:bg-blue-700 text-white text-sm px-6 h-9"
            >
              Accept Cookies
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}
